export default IconVenus => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-venus" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 9m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
  <path d="M12 14l0 7" />
  <path d="M9 18l6 0" />
</svg>`;